import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../common/Button/Button";
import InputLogo from "../../common/InputLogo/InputLogo";
import Input from "../../common/Input/Input";
import { Toaster } from "../../common/Toaster/Toaster";
import { verifyOtp, resendOtp } from "../../service/AuthWellDhanService";
import { ApiContext } from "../../context/MyContext";
import { useUtils } from "../../context/UtilsContext";
import { getCurrentEmployee } from "../../service/CorporateWellDhanService";
function OtpComponent() {
  const location = useLocation();
  const navigate = useNavigate();
  const { login, setEmployeeInfo } = useContext(ApiContext);
  const { fetchCorporateUtils } = useUtils();
  const {
    email,
    type, // "login", "register", "forgot"
    event_type_id, // For verify-otp and resend-otp
    redirectPath // Path to redirect after successful login
  } = location.state || {};

  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(60);
  const [showResend, setShowResend] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
const [postOtpVerified, setPostOtpVerified] = useState(false);
const { fetchDietCommonUtils } = useUtils();
const [flash, setFlash] = useState(() => location.state?.flash || null);

  useEffect(() => {
    if (flash) {
      const t = setTimeout(() => setFlash(null), 3000);
      return () => clearTimeout(t);
    }
  }, [flash]);
  // Redirect if OTP page is accessed directly
  useEffect(() => {
    if (!email || !event_type_id) navigate("/login");
  }, [email, event_type_id, navigate]);

  // Timer for resend button
  useEffect(() => {
    let interval = null;
    if (!showResend && timer > 0) {
      interval = setInterval(() => setTimer(t => t - 1), 1000);
    } else if (timer === 0) {
      setShowResend(true);
    }
    return () => clearInterval(interval);
  }, [showResend, timer]);

const handleVerify = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  const payload = {
    otp,
    event_type_id,
  };

  const result = await verifyOtp(payload);
  setLoading(false);

  if (result.success) {
    const accessToken = result.data?.access_token || result.data?.data?.access_token;
    if (accessToken) {
      localStorage.setItem('access_token', accessToken);
    } else {
      console.warn("No access_token found in OTP response!", result.data);
    }

    if (type === "login" || type === "register") {
      login && login();
      setPostOtpVerified(true);
       // --- FETCH EMPLOYEE DATA & SET IN CONTEXT ---
      try {
        // 1. Fetch corporate utils 
        await fetchCorporateUtils();

        // 2. Fetch current employee from subscriptions and setEmployeeInfo
        const empRes = await getCurrentEmployee();
        if (empRes.success && empRes.data?.data) {
          const data = empRes.data.data;
          const empDept = data.departments?.[0]?.title ?? "";
          const empRole = data.roles?.[0]?.title ?? "";
          setEmployeeInfo({
            empId: data.user_id,
            empName: `${data.first_name || ""} ${data.last_name || ""}`.trim(),
            empMail: email ?? "",
            empDept,
            empRole,
            userType: "",
          });
        }
        // 3. Fetch diet common utils
        await fetchDietCommonUtils();
      } catch (err) {
        console.error("Error fetching and setting employee info:", err);
      }
      setSuccessMessage("Login successful");
    setTimeout(() => {
      // Redirect to the stored path or default to /home
      const finalRedirectPath = redirectPath || localStorage.getItem('redirectAfterLogin') || '/home';
      localStorage.removeItem('redirectAfterLogin'); // Clear it
      navigate(finalRedirectPath);
    }, 1000); 

    } else if (type === "forgot") {
      setSuccessMessage("OTP verified successfully");
      setTimeout(() => {
      navigate("/update-password", { state: { email, event_type_id } });},500);
    }
  } else {
    setError(result.message);
  }
};

  const handleResend = async () => {
    setError("");
    setShowResend(false);
    setTimer(60);
    const result = await resendOtp({ event_type_id });

    if (!result.success) {
      setError(result.message);
      setShowResend(true);
      setTimer(0);
    }
  };
useEffect(() => {
  if (successMessage) {
    const timer = setTimeout(() => setSuccessMessage(""), 3000);
    return () => clearTimeout(timer);
  }
}, [successMessage]);

  return (
     <div className="w-full flex justify-center items-center min-h-screen">
      {flash && <Toaster message={flash.message} type={flash.type} />}
      {error && <Toaster message={error} type="error" />}
      {successMessage && <Toaster message={successMessage} type="success" />}
      <div className="bg-app-bg w-1/3 min-w-[300px] rounded-2xl drop-shadow-lg pb-12 pt-6 px-6">
        <InputLogo text="Enter OTP" />
        <form className="w-full flex flex-col items-center" onSubmit={handleVerify}>
          <Input
            name="otp"
            value={otp}
            onChange={e => setOtp(e.target.value)}
            placeholder="Enter OTP"
            errorMessage="Please enter a valid OTP."
            className="w-1/2 bg-input-bg"
            type="number"
            required
          />
          {loading || postOtpVerified ? (
            <span className="loader mt-5"></span>
          ) : (
            <Button
              type="submit"
              text="Verify"
              className="bg-orange-primary text-white w-1/2 mt-8"
            />
          )}
        </form>
       <p className="text-center mt-4 text-sm text-gray-700">
        {postOtpVerified ? (
          <span className="text-gray-400">Verifying company data...</span>
        ) : showResend ? (
          <span
            className="cursor-pointer text-orange-primary font-medium"
            onClick={handleResend}
          >
            Resend OTP
          </span>
        ) : (
          <>Resend OTP in {timer}s</>
        )}
      </p>

      </div>
    </div>
  );
}

export default OtpComponent;
